import { DataGrid } from "@serenity-is/corelib";

var getPagerOptionsOrg = DataGrid.prototype['getPagerOptions'];
DataGrid.prototype['getPagerOptions'] = function () {
    var opt = getPagerOptionsOrg.call(this);
    opt.rowsPerPage = 200;
    opt.rowsPerPageOptions = [20, 200, 500, 2500];
    return opt;
};

var getViewOptionsOrg = DataGrid.prototype['getViewOptions'];
DataGrid.prototype['getViewOptions'] = function () {
    var opt = getViewOptionsOrg.call(this);
    if (opt.rowsPerPage == 100)
        opt.rowsPerPage = 200;
    return opt;
};
